import { render, staticRenderFns } from "./transformForm.vue?vue&type=template&id=773e899e&scoped=true"
import script from "./transformForm.vue?vue&type=script&lang=js"
export * from "./transformForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773e899e",
  null
  
)

export default component.exports